import { useTranslation } from "react-i18next";

const services = [
  {
    icon: "ri-customer-service-2-line",
    tag: "Agent",
    titleKey: "services.item0_title",
    descKey: "services.item0_desc",
    metricKey: "services.item0_metric",
    featureKeys: ["services.item0_feature0", "services.item0_feature1", "services.item0_feature2"],
  },
  {
    icon: "ri-headphone-line",
    tag: "Agent",
    titleKey: "services.item1_title",
    descKey: "services.item1_desc",
    metricKey: "services.item1_metric",
    featureKeys: ["services.item1_feature0", "services.item1_feature1", "services.item1_feature2"],
  },
  {
    icon: "ri-magic-line",
    tag: "Automation",
    titleKey: "services.item2_title",
    descKey: "services.item2_desc",
    metricKey: "services.item2_metric",
    featureKeys: ["services.item2_feature0", "services.item2_feature1", "services.item2_feature2"],
  },
  {
    icon: "ri-database-2-line",
    tag: "Data",
    titleKey: "services.item3_title",
    descKey: "services.item3_desc",
    metricKey: "services.item3_metric",
    featureKeys: ["services.item3_feature0", "services.item3_feature1", "services.item3_feature2"],
  },
  {
    icon: "ri-code-box-line",
    tag: "Build",
    titleKey: "services.item4_title",
    descKey: "services.item4_desc",
    metricKey: "services.item4_metric",
    featureKeys: ["services.item4_feature0", "services.item4_feature1", "services.item4_feature2"],
  },
  {
    icon: "ri-line-chart-line",
    tag: "Strategy",
    titleKey: "services.item5_title",
    descKey: "services.item5_desc",
    metricKey: "services.item5_metric",
    featureKeys: ["services.item5_feature0", "services.item5_feature1", "services.item5_feature2"],
  },
];

export default function Services() {
  const { t } = useTranslation();

  return (
    <section id="servicios" className="relative py-24 md:py-32 bg-[#0a1628] overflow-hidden">
      <div className="relative max-w-7xl mx-auto px-8 md:px-16 lg:px-24">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/10 text-accent-300 text-xs font-semibold border border-background-50/10">
              <span className="w-2 h-2 rounded-full" style={{ background: 'linear-gradient(90deg, #215E88, #02B36D)' }}></span>
              {t("services.badge")}
            </span>
            <h2 className="mt-5 font-heading text-3xl md:text-5xl font-bold leading-tight">
              <span style={{ color: '#FFFFFF' }}>{t("services.h2_part1")}</span>
              <span style={{ background: 'linear-gradient(90deg, #215E88, #02B36D)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>{t("services.h2_gradient")}</span>
            </h2>
          </div>
          <p className="max-w-md text-white/80 text-sm md:text-base leading-relaxed">
            {t("services.description")}
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {services.map((s) => (
            <div
              key={s.titleKey}
              className="glass-card-dark glow-border rounded-lg p-6 md:p-7 flex flex-col h-full"
              style={{
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
              }}
              onMouseEnter={(e) => {
                (e.currentTarget as HTMLDivElement).style.transform = 'translateY(-4px)';
                (e.currentTarget as HTMLDivElement).style.boxShadow = '0 0 0 1px rgba(2,179,109,0.2), 0 8px 32px rgba(2,179,109,0.15), 0 4px 16px rgba(2,179,109,0.1)';
              }}
              onMouseLeave={(e) => {
                (e.currentTarget as HTMLDivElement).style.transform = 'translateY(0)';
                (e.currentTarget as HTMLDivElement).style.boxShadow = 'none';
              }}
            >
              <div>
                <div className="flex items-center justify-between">
                  <div className="w-12 h-12 flex items-center justify-center rounded-md bg-gradient-to-br from-primary-600 to-accent-500 text-background-50">
                    <span className="w-6 h-6 flex items-center justify-center">
                      <i className={`${s.icon} text-2xl`}></i>
                    </span>
                  </div>
                  <span className="text-[10px] font-bold tracking-widest uppercase px-2.5 py-1 rounded-full bg-accent-500/15 text-accent-300 border border-accent-500/25">
                    {s.tag}
                  </span>
                </div>
                <h3 className="mt-5 font-heading text-lg md:text-xl font-semibold" style={{ color: '#FFFFFF' }}>
                  {t(s.titleKey)}
                </h3>
                <p className="mt-2 text-sm leading-relaxed" style={{ color: 'rgba(255,255,255,0.8)' }}>
                  {t(s.descKey)}
                </p>
              </div>

              <div className="mt-auto w-full">
                <ul className="mt-5 flex flex-wrap gap-2 min-h-[56px] content-start mb-6">
                  {s.featureKeys.map((fk) => (
                    <li
                      key={fk}
                      className="text-[11px] font-medium px-2.5 py-1 rounded-full bg-white/5 border border-white/10"
                      style={{ color: 'rgba(255,255,255,0.85)' }}
                    >
                      {t(fk)}
                    </li>
                  ))}
                </ul>

                <div className="pt-5 border-t border-background-50/10 flex items-center justify-center">
                  <span className="text-accent-400 font-heading text-base font-bold">{t(s.metricKey)}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}